import { InputSelect } from "../../atoms/Inputs/InputSelect";
import { SelectOption } from "../../../common/types/selectOption";
import { ChangeEvent } from "react";

interface SensorSelectProps {
  params?: {
    ssrShipNo?: string;
    ssrMcyName?: string;
    ssrLowMcyName?: string;
    ssrName?: string;
  };
  value?: string;
  errored?: boolean;
  onChange: (e: ChangeEvent<HTMLSelectElement>) => void;
  selectOptions?: SelectOption[];
  width?: number;
}
export const SensorSelect = ({
  params,
  value,
  errored,
  width = 120,
  onChange,
  selectOptions,
}: SensorSelectProps) => {
  //     return await request<SelectOption[]>({
  //       method: "GET",
  //       url: `/sensor/select/options`,
  //       params: params,
  //     });
  //   },
  // });

  return (
    <InputSelect
      width={width}
      size="sm"
      placeholder="센서 선택"
      options={selectOptions}
      onChange={onChange}
      value={value}
      errored={errored}
    />
  );
};
